export * from './ports/types';
export { MockDesktopAmbient } from './mocks/mockDesktopAmbient';

export {
  type IPlatformBridgeAdapter,
  type WindowBounds,
  type DisplayWorkArea,
} from './internal/bridges/IPlatformBridgeAdapter';

export { NullPlatformBridgeAdapter } from './internal/bridges/NullPlatformBridgeAdapter';
export { WebEmulatedBridgeAdapter } from './internal/bridges/WebEmulatedBridgeAdapter';
export { ElectronBridgeAdapter, type ElectronAmbientAPI } from './internal/bridges/ElectronBridgeAdapter';

export {
  NativePlatformBridge,
  type PlatformType,
  type NativePlatformBridgeOptions,
} from './internal/NativePlatformBridge';

export {
  TransparentWindowManager,
  type WindowConfig,
} from './internal/TransparentWindowManager';

export {
  InteractionPassthrough,
  type SnapCorner,
} from './internal/InteractionPassthrough';

export {
  DesktopAmbientService,
  type DesktopAmbientServiceOptions,
} from './internal/DesktopAmbientService';

import type { IDesktopAmbientPort } from './ports/types';
import { DesktopAmbientService, type DesktopAmbientServiceOptions } from './internal/DesktopAmbientService';

/**
 * DesktopAmbientPort のファクトリ関数
 * 本番・プロトタイプ向けの本実装ファサード (DesktopAmbientService) を生成して返却
 */
export function createDesktopAmbientPort(options?: DesktopAmbientServiceOptions): IDesktopAmbientPort {
  return new DesktopAmbientService(options);
}
